import React, { Component } from 'react';
import DarkGreyCircle from './DarkGreyCircle';
import LightGreyCircle from './LightGreyCircle';
import GreenCentralCircle from './GreenCentralCircle';
import GreyCentralCircle from './GreyCentralCircle';
import RedCentralCircle from './RedCentralCircle';
import Label from './Label';
import Button from './Button';
import './styles.css';

class StepperItemLayout extends Component {
	render() {
		return <div className="stepper-item-layout">{this.props.children}</div>;
	}
}
Object.assign(StepperItemLayout, {
	DarkGreyCircle,
	LightGreyCircle,
	GreenCentralCircle,
	GreyCentralCircle,
	RedCentralCircle,
	Label,
	Button
});

export default StepperItemLayout;
